// Emoji regex from https://stackoverflow.com/a/64007175
const emojiRegex = /\p{Extended_Pictographic}/u;

function checkCharacterEmoji(characterCard) {
  if (emojiRegex.test(characterCard.hero.name)) return true;
  if (emojiRegex.test(characterCard.hero.specialAbility)) return true;

  if (characterCard.sidekick.quantity) {
    if (emojiRegex.test(characterCard.sidekick.name)) return true;
  } else {
    if (emojiRegex.test(characterCard.sidekick.quote)) return true;
  }
  return false;
}

function checkRuleEmoji(ruleCard) {
  if (emojiRegex.test(ruleCard.content)) return true;
  if (emojiRegex.test(ruleCard.title)) return true;

  return false;
}

function checkCardEmoji(card) {
  if (emojiRegex.test(card.title)) return true;
  if (emojiRegex.test(card.description)) return true;

  return false;
}

export default function checkEmoji(
  deck,
  includeCharacterCards = true,
  includeRuleCards = true,
  includeDeckCards = true
) {
  if (includeCharacterCards) {
    if (checkCharacterEmoji(deck)) return true;

    const hasEmoji = deck.extraCharacters.some(character => {
      return checkCharacterEmoji(character);
    });

    if (hasEmoji) return true;
  }

  if (includeRuleCards) {
    const hasEmoji = deck.ruleCards.some(ruleCard => {
      return checkRuleEmoji(ruleCard);
    });

    if (hasEmoji) return true;
  }

  if (includeDeckCards) {
    const hasEmoji = deck.cards.some(card => {
      return checkCardEmoji(card);
    });

    if (hasEmoji) return true;
  }

  return false;
}
